import React from 'react'
import PropTypes from 'prop-types'

const ToggleButton = ({ toggle, active, activeIcon, inactiveIcon }) => {
    const iconClass = active ? activeIcon : inactiveIcon
    return (
        <button
            className="btn btn-primary btn-sm"
            onClick={toggle}>
            <i className={iconClass}/>
        </button>)
}


ToggleButton.propTypes = {
    toggle: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    activeIcon: PropTypes.string.isRequired,
    inactiveIcon: PropTypes.string.isRequired,
}

export default ToggleButton



// WEBPACK FOOTER //
// ./src/modules/form/component/ToggleButton.js